module.exports = __webpack_public_path__ + "img/symbol_10.00fcafe0.png";